export default __webpack_public_path__ + "static/324-24224d8def654c68a7f47b31f6ed2594.gif";